/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StkRcpt02Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const stkRcpt02ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const stkRcpt02FetchStkRcpt02Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const stkRcpt02FetchStkRcpt02Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const stkRcpt02AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const stkRcpt02RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const stkRcpt02SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const stkRcpt02CreateStkRcpt02Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const stkRcpt02CreateStkRcpt02Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StkRcpt02Types.STK_RCPT02_RESET_TIMESTAMP]: stkRcpt02ResetTimestamp,
  [StkRcpt02Types.STK_RCPT02_FETCH_STK_RCPT02_LOADING]: stkRcpt02FetchStkRcpt02Loading,
  [StkRcpt02Types.STK_RCPT02_FETCH_STK_RCPT02_SUCCESS]: stkRcpt02FetchStkRcpt02Success,
  [StkRcpt02Types.STK_RCPT02_ADD_SELECTED_DOCUMENTS]: stkRcpt02AddSelectedDocuments,
  [StkRcpt02Types.STK_RCPT02_REMOVE_SELECTED_DOCUMENTS]: stkRcpt02RemoveSelectedDocuments,
  [StkRcpt02Types.STK_RCPT02_SET_WORKSPACE_VISIBLE]: stkRcpt02SetWorkspaceVisible,
  [StkRcpt02Types.STK_RCPT02_CREATE_STK_RCPT02_LOADING]: stkRcpt02CreateStkRcpt02Loading,
  [StkRcpt02Types.STK_RCPT02_CREATE_STK_RCPT02_SUCCESS]: stkRcpt02CreateStkRcpt02Success
});
